'use strict';

const formValidation = require('../components/formValidation');
const conditionalRequired = require('../formHandling/conditionalRequired');
const addressHelpers = require('../checkout/address');
const pwdToggler = require('../components/pwdToggler');
const {alertMessage} = require('../common/common');
const {setPseudoHTMLFeedbackElement} = require('../common/common');
const {init: initBirthdayMask} = require('../inputBirthdayMask');

const location = window.location;

const setMaxDate = () => {
    if ($('.js-min-age-input').length > 0) {
        const today = new Date();
        const date = $('.js-min-age-input').attr('minlength');
        let eighteenYearsAgo = new Date(today.getFullYear() - date, today.getMonth(), today.getDate());
        const maxDate = eighteenYearsAgo.toISOString().split('T')[0];
        $('input[type="date"]').attr('max', maxDate);
    }
}

    /**
     * Parses the html for a modal window
     * @param {string} html - representing the body and footer of the modal window
     *
     * @return {Object} - Object with properties body and footer.
     */
    function parseHtml(html) {
        var $html = $('<div>').append($.parseHTML(html));
        return { body: $html.contents() };
        return { body: body };
    }

function handleAjax(url, form, type, successCallback, errorCallback) {
    $('body').spinner().start();
    $.ajax({
        url: url,
        type: type,
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            successCallback(data);
        },
        error: function (data) {
            $('body').spinner().stop();
            errorCallback(data);
        }
    });
}

function submitRegistrationForm(form, e) {
    
    const globalMessageWrap = $(form).find('.js-global-error-message');
    const url = form.attr('action');

    handleAjax(url, form, 'post', function (data) {

        if (!data.success) {
            alertMessage(data.errorMessage, 'cc-alert--danger');
            $('form.js-registration-form').trigger('login:register:error', data);
            formValidation(form, data);
            $('body').spinner().stop();
        } else {

            $(globalMessageWrap).empty();
            $('form.js-registration-form').trigger('login:register:success', data);

            if ($(form).closest('.js-login-wrapper').hasClass('js-login-page')) {
                location.href = data.redirectUrl;
            } else {
                window.localStorage.setItem("wasRegistered", true);

                if (sessionStorage.getItem('subscriptionFlow')) {
                    const subscriptionFlow = JSON.parse(sessionStorage.getItem('subscriptionFlow'));
                    if (subscriptionFlow && subscriptionFlow.cartStep) {
                        subscriptionFlow.loginStep = true;
                        sessionStorage.setItem('subscriptionFlow', JSON.stringify(subscriptionFlow));
                    }
                }

                window.location.reload();
            }
        }
    }, function (err) {
        alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
    });

}

// Helper to handle address validity check + submission
async function handleAddressValidationAndSubmit($form, e) {
    try {
        const resultAddressValidity = await addressHelpers.methods.checkAddressValidity($form);
        if (typeof (resultAddressValidity) === 'boolean' && !resultAddressValidity) {
            submitRegistrationForm($form, e);
        }
        else if (resultAddressValidity?.hasAddressChanged === 'false') {
            addressHelpers.methods.updateDistributionCode($form, resultAddressValidity.distributionCodeDP);
            submitRegistrationForm($form, e);
        } else {
            addressHelpers.methods.handleAddressValidationModal(resultAddressValidity, $form);
        }
    } catch (e) {
        alertMessage(e, 'cc-alert--danger');
    }
}

module.exports = {
    init: function () {
        conditionalRequired.init();
    },
    login: function () {
        $('body').on('submit','form.js-login-form', function(e) {
            e.preventDefault();
            const form = $(this);
            const input = form.find('input[data-password]');
            const invalidFeed = input.closest('.cc-form__wrap').find('.invalid-feedback');
            const containerInput = invalidFeed.closest('.cc-form__wrap');
            const url = form.attr('action');
        
            handleAjax(url, form, 'post', function (data) {
                if (!data.success) {
                    if (data.logoutAndRedirectCustomer) {
                        alertMessage(data.error[0], 'alert-danger');
                        const homeUrl = $('#js-page-dataset').data('home');

                        $.ajax({
                            url: data.logoutUrl,
                            method: 'GET',
                            success: function (data) {
                                if (data.success) {
                                    setTimeout(() => {
                                        window.location.href = homeUrl;
                                    }, 3000);
                                }
                            },
                            error: function () {
                                $('body').spinner().stop();
                            }
                        });
                    } else {
                        formValidation(form, data, invalidFeed, containerInput);
                        $('form.js-login-form').trigger('login:error', data);
                        $('body').spinner().stop();
                        //PWC-NOA-449 inject captcha template only if is not already present
                        //if exist the div of captcha template injected because user navigate from 'extra EU' DO NOT inject another captcha
                        if (data.captchaTemplate && $('#captchaTemplate').length <= 1 && $('#captchaExtraEUTemplate').length <= 0) {
                            $('#captchaTemplate').empty().append(data.captchaTemplate);
                        }
                    }
                } else {
                    $('form.js-login-form').trigger('login:success', data);
                    containerInput.removeClass('cc-form__wrap--error');
                    invalidFeed.removeClass('cc-message--visible');

                    if ($(form).closest('.js-login-wrapper').hasClass('js-login-page')) {
                        location.href = data.redirectUrl;
                    } else {
                        window.location.reload();
                    }

                    if (sessionStorage.getItem('subscriptionFlow')) {
                        const subscriptionFlow = JSON.parse(sessionStorage.getItem('subscriptionFlow'));
                        if (subscriptionFlow && subscriptionFlow.cartStep) {
                            subscriptionFlow.loginStep = true;
                            sessionStorage.setItem('subscriptionFlow', JSON.stringify(subscriptionFlow));
                        }
                    }
                }
            }, function (data) {
                $('form.js-login-form').trigger('login:error', data);
            });

            return false;
        });
    },

    logout: function () {
        $('body').on('click','.js-dropdown-logout', function(e) {
            e.preventDefault();
            const url = $(this).attr('value') ? $(this).attr('value') : $(this).attr('href');
            const notLoggedOutMessage = $('.js-dropdown-logout').data('message');

            const homeUrl = $('#js-page-dataset').data('home');
            const currentRoute = $('#js-page-dataset').data('route');
            
            $('body').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (data) {
                    if (data.success) {
                        if (currentRoute !== 'Order-Confirm') {
                            window.location.reload();
                        } else {
                            window.location.href = homeUrl;
                        }
                        return;
                    }

                    $('body').spinner().stop();
                },
                error: function () {
                    alertMessage(notLoggedOutMessage, 'alert-danger');
                    $('body').spinner().stop();
                }
            });
        })
    },

    register: function () {
        $('body').on('submit','form.js-registration-form', async function(e) {
            e.preventDefault();
            const form = $(this);

            try {
                const $submitBtn = $('.js-addressform-btn-wrapper button.submit-billing');
                if ($submitBtn.data('address-validation') === 'true') {
                    $submitBtn.data('address-validation', 'false');
                    submitRegistrationForm(form, e);
                    return false;
                }

                // Country-specific validation gate (DE/AT/CH)
                if (addressHelpers.methods.shouldValidateAddressForCountry(form)) {
                    await handleAddressValidationAndSubmit(form, e);
                } else {
                    submitRegistrationForm(form, e);
                }
            } catch (err) {
                alertMessage(err, 'cc-alert--danger');
            }
            return false;

        });
    },

    completeProfile: function () {
        $('body').on('submit','form.js-complete-profile-form', function(e) {
            e.preventDefault();
            const form = $(this);
            const globalMessageWrap = $(form).find('.js-global-error-message');
            const url = form.attr('action');

            handleAjax(url, form, 'post', function (data) {
                if (!data.success) {
                    alertMessage(data.errorMessage, 'cc-alert--danger');
                    formValidation(form, data);
                    $('form.js-complete-profile-form').trigger('login:completeProfile:error', data);
                } else {
                    $(globalMessageWrap).empty();
                    $('form.js-complete-profile-form').trigger('login:completeProfile:success', data);
                    location.href = data.redirectUrl;
                }
            }, function (err) {
                alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
            });

            return false;
        });
    },

    resubmitEmail: function () {
        $('body').on('submit', 'form.js-confirm-mail-form', function (e) {
            e.preventDefault();
            const form = $(this);
            const globalMessageWrap = form.find('.js-global-error-message');
            const url = form.attr('action');
            const emailInput = form.find('#resubmit-email').val();

            handleAjax(url, form, 'post', function (data) {
                if (!data.success) {
                    alertMessage(data.errorMessage, 'cc-alert--danger');
                    $('body').spinner().stop();
                    formValidation(form, data);
                } else {
                    let parsedHtml = parseHtml(data.renderedTemplate);
                    $('body').spinner().stop();
                    $('.js-render-resubmitMail').empty();
                    $('.js-render-resubmitMail').html(parsedHtml.body);
                    alertMessage(data.successMessage, 'cc-alert--success');
                }
            }, function (err) {
                $('body').spinner().stop();
                alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
            });

            return false;
        });
    },

    resetPassword: function () {
        $('body').on('submit','form.js-reset-password-form', function(e) {
            e.preventDefault();
            const form = $(this);
            const url = form.attr('action');
            const modalTitle = $(this).closest('.js-modal-reset').find('.js-modal-subtitle');

            handleAjax(url, form, 'post', function (data) {
                if (!data.success) {
                    formValidation(form, data);
                    alertMessage(data.errorMessage, 'cc-alert--danger');
                } else {
                    modalTitle.empty();
                    $('.request-password-body').empty().append(
                        '<div class="alert alert-dismissible cc-alert cc-alert--success show" role="alert"><div class="d-flex align-items-center col-12 pl-0"><span class="cc-alert__message js-alert-message-return" aria-live="polite" aria-atomic="true">' + data.receivedMsgBody + 
                        '</span></div></div>'
                    );
                    $('.cc-alert--warning').remove();
                    $('.send-email-btn').remove();
                    $('body').spinner().stop();
                }
            }, function () {
                $('body').spinner().stop();
            });

            return false;
        });
    },

    clearResetForm: function () {
        $('body').on('hidden.bs.modal', '#login .modal',  function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    }
};

$(() => {
    pwdToggler.initializeClass();
    setMaxDate();
    const modal = $('.js-loginModal');
    const buttonEye = $('.js-loginModal').find('.js-eye').first();
    const buttonSpan = $(buttonEye).find('span');
    const iconCalendar = $(modal).find('.js-calendar');
    const iconCalendarWrap = $(modal).find('.js-input-icon');
    setTimeout(function() {
        $('.js-form-select.selectpicker').selectpicker('refresh');
    },500);

    $('body').on('click', '.js-switch-to-register', function() {
        modal.find('.cc-modal__close').appendTo(modal.find('.js-register'));
        modal.attr('data-step', 'register');

        const inputDate =  $(modal).find('.js-register input[type="date"]');
        //$(iconCalendar).removeClass('d-none');
        $(iconCalendarWrap).insertAfter(inputDate);
    });

    $('body').on('click', '.js-switch-to-login', function(e) {
        e.preventDefault();
        modal.find('.cc-modal__close').appendTo(modal.find('.js-login'));
        modal.attr('data-step', 'login');
    });

    $('body').on('hide.bs.modal', "#loginModal", function (e) {
        modal.find('.cc-modal__close').appendTo(modal);
        modal.attr('data-step', 'login');
        $(modal).removeClass("pr-0");
    });

    $('.js-modal-reset').on('show.bs.modal', function () {
        $(this).addClass("pr-0");
    });

    $('.js-modal-reset').on('hide.bs.modal', function () {
        $(this).removeClass("pr-0");
    });

    $('.js-complete-profile-form .js-form-control').each(function() {
        if ($(this).val() !== '') {
            $(this).prop('disabled', true);
        }
    });

    if (window.localStorage.getItem("wasRegistered")) {
        const newUserMessageSuccess = $('.js-loginModal').data('new-user');
        alertMessage(newUserMessageSuccess, 'alert-success cc-alert--success');
        window.localStorage.removeItem("wasRegistered");
    }
});

$('body').on('shown.bs.modal', '.js-loginModal', function (e) {
    const modal = $('.js-loginModal');                        // ← lokal definieren
    const buttonSpan = modal.find('.js-eye').first().find('span');  // ← lokal definieren
    const selectedUrl = $(this).data('href');
    $.ajax({
        url: selectedUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            if (data.renderedTemplate) {
                $('.js-loginModal form').find('.js-eye-form').empty().html(buttonSpan);
                $('.js-loginModal .cc-modal__dialog').empty().append(data.renderedTemplate);
                modal.find('.cc-modal__close').appendTo(modal.find('.js-login'));
                $(modal).addClass("pr-0");
                const selectPickerElement = modal.find('.js-form-select.selectpicker');
                selectPickerElement.find('option[value=""]').hide().parent().selectpicker('refresh');
                pwdToggler.initializeClass();
                setMaxDate();
                setPseudoHTMLFeedbackElement();
                initBirthdayMask(modal[0]);
            }
        },
        error: function () {
            console.error("error");
        }
    });
});